import React, {
  useEffect,
  useState,
  createContext,
  useCallback,
  useContext,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../redux/authApi";
import { setProfile } from "../redux/authSlice";

// Create the AuthContext
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const { user: reduxUserData, loading: reduxLoading } = useSelector(
    (state) => state.auth
  );
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  const fetchUser = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getUser();
      setUser(response?.data || null);
      await dispatch(setProfile(response?.data));
    } catch (error) {
      console.error("Error fetching user:", error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    if (reduxUserData) {
      setUser(reduxUserData);
      setLoading(false);
    } else {
      fetchUser();
    }
  }, [reduxUserData, fetchUser]);

  return (
    <AuthContext.Provider value={{ user, loading: loading || reduxLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom Hook
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export default AuthProvider;
